<template>
  <div>
    <steps-order
      :step=2
    ></steps-order>

    <section class="invoice cartStyle">
      <!-- title row -->
      <div class="row">
        <div class="col-xs-12">
          <h2 class="page-header">
            <i class="fa fa-send"></i> Choix du mode de livraison
          </h2>
        </div>
      </div>
      <!-- Table row -->
      <div class="row choixModeLivraison">
        <div class="col-md-12 ">

          <div class="col-md-1">
            <div class="check" @click.prevent="(livraisonByAdresse=!livraisonByAdresse) && (livraisonByPtRelais=false)">
              <div class="checkInside" v-if="livraisonByAdresse">
                <span class="fa fa-check" style="color:white"></span>
              </div>
            </div>
            <!--              <input type="checkbox" :checked="livraisonByAdresse" value="adresse" name="deliveryType" class="hidden-radio">-->
          </div>
          <div class="col-md-11">
            <div @click.prevent="(livraisonByAdresse=!livraisonByAdresse) && (livraisonByPtRelais=false)" class="info-box-content" >
              <span class="info-box-number">Livraison à l'adresse de votre choix</span>
              <span class="technical-hide-when-opened" style="display: inline;">
               Livraison Bpost à l'adresse ci-dessous. Vous avez la possibilité de modifier cette adresse.</span>
            </div>

            <b-collapse visible v-model="livraisonByAdresse" style="margin-top: 20px;" class="">
              <b-card>
                <div class="row" v-if="true">
                  <div class="col-md-12">
<!--                    <div class="form-group" :class="{'has-error': errors.has('mail') }">-->
<!--                      <label for="mail">E-mail:</label>-->
<!--                      <input class="form-control" type="text" v-validate="'required|email'" v-model="adresse.mail"-->
<!--                             id="mail" name="mail">-->
<!--                      <span v-show="errors.has('mail')" class="help-block">Adresse mail incorrecte</span>-->
<!--                    </div>-->
                    <div class="form-group" :class="{'has-error': errors.has('nom') }">
                      <label for="nom">Nom:</label>
                      <input class="form-control" type="text" v-validate="'required|min:2|max:255'"
                             v-model="adresse.nom" id="nom" name="nom">
                      <span v-show="errors.has('nom')" class="help-block">Le nom doit comporter entre 2 et 255 caractères</span>

                    </div>
                    <div class="form-group" :class="{'has-error': errors.has('prenom') }">
                      <label for="prenom">Prénom:</label>
                      <input class="form-control" type="text" v-validate="'required|min:2|max:255'"
                             v-model="adresse.prenom" id="prenom" name="prenom">
                      <span v-show="errors.has('prenom')" class="help-block">Le prénom doit comporter entre 2 et 255 caractères</span>

                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('adresse') }">
                      <label for="adresse">N° et nom de rue:</label>
                      <input class="form-control" type="text" v-validate="'required|min:1|max:512'"
                             v-model="adresse.adresse" id="adresse" name="adresse">
                      <span v-show="errors.has('adresse')" class="help-block">L'adresse ne peut être vide et doit comporter moins de 512 caractères</span>

                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('complement') }">
                      <label for="adresse">Complément d’adresse:</label>
                      <input class="form-control" type="text" v-validate="'max:512'" v-model="adresse.complement"
                             id="complement" name="complement">
                      <span v-show="errors.has('complement')" class="help-block">Le complément doit comporter moins de 512 caractères</span>

                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('cp') }">
                      <label for="cp">Code postal:</label>
                      <input class="form-control" type="text" v-validate="'required|min:4|max:5'" v-model="adresse.cp"
                             id="cp" name="cp">
                      <span v-show="errors.has('cp')" class="help-block">Le code postal n'est pas valide</span>
                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('ville') }">
                      <label for="nom">Ville:</label>
                      <input class="form-control" type="text" v-validate="'required|min:2|max:255'"
                             v-model="adresse.ville" id="ville" name="ville">
                      <span v-show="errors.has('ville')" class="help-block">Le nom de la ville doit comporter moins de 255 caractères</span>
                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('tel') }">
                      <label for="tel">Téléphone / GSM:</label>
                      <input class="form-control" type="text" v-validate="'max:25'" v-model="adresse.telephone_gsm"
                             id="tel" name="tel">
                      <span v-show="errors.has('club[tel]')" class="help-block">Numéro de téléphone incorrect</span>
                    </div>

                  </div>
                </div>
              </b-card>

              <div class="col-xs-12">
<!--                <router-link :to="{name: 'Confirm'}">-->
                  <a type="button" class="btn btn-primary pull-right"
                     @click.prevent="goToChoixPayement()"
                     :disabled="!verifAdresseForm()">
                    <i class="fa fa-send"></i>
                    Envoyer à cette adresse
                  </a>
<!--                </router-link>-->
              </div>

            </b-collapse>
          </div>
        </div>
        <br>
        <div class="col-md-12">
        <hr>
        </div>
        <br>
        <div class="col-md-12 disabled">

          <div class="col-md-1">
            <div class="check" @click.prevent="">
              <div class="checkInside" v-if="livraisonByPtRelais">
                <span class="fa fa-check" style="color:white"></span>
              </div>
            </div>
            <!--              <input type="checkbox" :checked="livraisonByAdresse" value="adresse" name="deliveryType" class="hidden-radio">-->
          </div>
          <div class="col-md-11">
            <div class="info-box-content" style="margin: 0">
              <span class="info-box-number">Livraison dans un point relais</span>
              <span class="technical-hide-when-opened" style="display: inline;">
               Prochainement disponible</span>
            </div>
          </div>
        </div>
      </div>

<!--      <div class="row no-print" style="margin-bottom: 0">-->
<!--        <hr>-->
<!--        <div class="col-xs-12">-->
<!--          <small class="">Vous pourrez vérifier votre commande à la prochaine étape avant d'effectuer le-->
<!--            payement.</small>-->
<!--        </div>-->
<!--      </div>-->
    </section>
  </div>
</template>

<script type="text/babel">
  import Auth from '@/auth'
  import {mapGetters, mapActions} from 'vuex'
  import stepsOrder from '../stepsOrder'
  let _ = require('lodash')
  export default {
    data() {
      return {
        livraisonByAdresse: false,
        livraisonByPtRelais: false,
        adresse: {
          mail: "",
          nom: "",
          prenom: "",
          adresse: "",
          complement: "",
          cp: "",
          ville: "",
          telephone_gsm: "",
        }
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        this.setAdresse();
      })
    },
    methods: {
      ...mapActions({
        setAdresseForOrder:'setAdresseForOrder',
        setModeLivraison:'setModeLivraison',
        setStepOrder:'setStepOrder'

      }),
      goToChoixPayement:function() {
        this.setModeLivraison(this.livraisonByAdresse ? 'livraisonByAdresse':'livraisonByPtRelais')
        this.setStepOrder({step:'step2',value:true})
        this.$router.push({
          name: 'ChoixPayement',
          params: {
            // club: object.club_slug
          }
        })
      },
      setAdresse: function () {
        this.adresse = {
          mail: this.getMember.mail ? this.getMember.mail : "",
          nom: this.getMember.nom ? this.getMember.nom : "",
          prenom: this.getMember.prenom ? this.getMember.prenom : "",
          adresse: this.getMember.adresse ? this.getMember.adresse : "",
          complement: this.getMember.complement ? this.getMember.complement : "",
          cp: this.getMember.cp ? this.getMember.cp : "",
          ville: this.getMember.ville ? this.getMember.ville : "",
          telephone_gsm: this.getMember.telephone_gsm ? this.getMember.telephone_gsm : "",
        }
      },
      verifAdresseForm: function () {
        let keysToVerif = [
          "mail",
          "nom",
          "prenom",
          "adresse",
          // "complement",
          "cp",
          "ville",
          // "telephone_gsm"
        ]
        let retour = true

        keysToVerif.forEach((item, index) => {
          if (!_.has(this.adresse,item) || _.trim(this.adresse[item]) == '')
            retour = false
        })
        return retour
      },
    },
    watch: {
      'adresse':function() {
        this.setAdresseForOrder(this.adresse)
      }
    },
    components: {
      stepsOrder
    },
    computed: {
      ...mapGetters({
        getCart: 'getCart',
        getMember: 'getMember',
      })
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Order/Livraison.vue